<template>
  <router-view />
  <DisclaimerPopup />
</template>

<script>
import DisclaimerPopup from "./components/DisclaimerPopup.vue";
export default {
  components: {
    DisclaimerPopup,
  },
  data: () => ({}),
};
</script>
